export default {
  dismissText: 'ÐÑÐ¼ÐµÐ½Ð°'
};
